import React from "react";
import { StyleSheet, View, ScrollView, Platform } from "react-native";

import Header from "../../common/header";
import ManaButton from "../../common/ManaButton";
import { openURL } from "../../../../helpers/utils.js";
import appStyles from "../../../appStyles";
import AppTheme from "../../AppTheme";

export default class KnowledgeBasePage extends React.Component {
  constructor(props) {
    super(props);
    this.controller = props.controller;

    this.state = {
      isLoading: true,
    };

    this.buttons = [
      {
        url: "https://mana.ai/blog/dopamine-stacking",
        text: "15 Dopamine Stacking Productivity Tips ",
      },
      {
        url: "https://mana.ai/blog/steps-to-set-goals",
        text: "7 Steps to Successful Goal Setting",
      },
      {
        url: "https://mana.ai/blog/it-doesnt-have-to-take-a-village",
        text: "Time Management Secrets for Moms",
      },
      {
        url: "https://mana.ai/blog/bouncing-back-from-bad-day",
        text: "How to Bounce Back from a Bad Day",
      },
      {
        url: "https://mana.ai/blog/benefits-of-journaling",
        text: "Decoding the Benefits of Journaling",
      },
      {
        url: "https://mana.ai/blog/avoid-distractions",
        text: "How to Avoid Distractions",
      },
      {
        url: "https://mana.ai/blog/time-management-secret",
        text: "The Power of No",
      },
      {
        url: "https://mana.ai/blog/how-to-set-work-life-boundaries",
        text: "Setting Work-Life Boundaries at Home",
      },
      {
        url: "https://mana.ai/blog/4-steps-to-seize-control-of-your-schedule",
        text: "4 Steps to Seize Control of your Schedule",
      },
      { url: "https://mana.ai/guides", text: "About Our Guides" },
    ];
  }

  componentDidMount = async () => {};

  render() {
    return (
      <View style={appStyles.container}>
        <Header
          title="Knowledge Base"
          subTitle="Methodologies to optimize Time Value"
          controller={this.controller}
          hideAvatar
          returnPage="rn:home_card"
        />

        <ScrollView style={[appStyles.scrollView, styles.scrollView]}>
          <View style={styles.buttons}>
            {this.buttons.map((button, index) => (
              <ManaButton
                key={index}
                hideShadow
                onPress={() => openURL(button.url)}
                style={[styles.button, { width: "100%" }]}
                styleText={[styles.buttonText]}
                text={button.text}
              />
            ))}
          </View>
        </ScrollView>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  scrollView: {
    paddingBottom: 130,
    paddingHorizontal: 10,
    paddingTop: 5,
    backgroundColor: "#FFF",
    marginTop: 0,
  },
  buttons: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  button: {
    width: 319,
    maxWidth: "100%",
    height: 44,
    backgroundColor: "#F3F2F1",
    marginBottom: 8,
    borderRadius: 6,

    shadowOpacity: 0.1,
    shadowOffset: { width: 0, height: 4 },
    shadowColor: "#000",
    shadowRadius: 5,
    elevation: 5,
  },
  buttonText: {
    color: "#FFF",
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 16,
    lineHeight: 17,
    letterSpacing: 1,
    letterSpacing: 0.175,
    color: AppTheme.DEFAULT_COLOR,
  },
});
